import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from '@app/core/service/navigation.service';
import { Router } from '@angular/router';
import { ConfirmationComponent } from '@app/shared/modals/confirmation';
import { UtilService, CONFIRMATION_MSGS } from '@app/core';
import { finalize } from 'rxjs/operators';
import { LOCAL_VAR } from '@app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DealHelpComponent } from '@app/shared/modals/deal-help/deal-help.component';
import { DealsService } from '@app/core/service/deals.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-custom-products',
  templateUrl: './custom-products.component.html',
  styleUrls: ['./custom-products.component.scss']
})
export class CustomProductsComponent implements OnInit {
  customCreateForm: FormGroup;
  modalRef: NgbModalRef;
  modalMode: string = 'create';
  editingItemId: string | null = null;
  @ViewChild('goto') nameInput: ElementRef;
  loggedInUserType: any = null;
  user: Authentication.User;
  productList: any;
  categories: any;
  fiterForm: FormGroup;
  isLoading = false;
  perPage = 10;
  sortDir = -1;
  currentPage = 1;
  sortBy = 'updateTime';
  pager = {
    perPage: 10,
    currentPage: 1,
    Totalrecords: 0,
    TotalPages: 0
  };
  PageList: any;
  timer: any;
  isProductLoading = false;
  productMaster: any[] = [];
  statusTypes = [
    { text: 'Enabled', value: false },
    { text: 'Disabled', value: true }
  ];

  currentStatus='';

  constructor(
    private modalService: NgbModal,
    private router: Router,
    public utilService: UtilService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
     private toastrService: ToastrService,
    private dealsService: DealsService
  ) {
    this.user = this.authenticationService.credentials.user;
    // console.log(this.user)
    this.loggedInUserType = this.user.userRoleId.slug;
    localStorage.setItem(LOCAL_VAR.selectedAgency, null);
    this.getProductsarray();
    this.createForm();
    this.getListByFilter();
  }

  ngOnInit() {

  }



  createForm() {
    this.fiterForm = this.formBuilder.group({
      name: [''],
      category: [''],
      brand: [''],
      order: [''],
      submittedBy: [''],
      disable: [''],
      perPage: 10
    });

    this.customCreateForm = this.formBuilder.group({
      name: ['', Validators.required],
      category: ['DOWC', Validators.required],
      brand: ['other'],
      order: [1],
      disable: [false]
    });

    this.fiterForm.valueChanges.subscribe(values => {
      //this.pager.currentPage = 1;
      //this.getListByFilter();
      const self = this;
      clearInterval(self.timer);
      self.timer = setInterval(() => {
        clearInterval(self.timer);
        self.getListByFilter();
      }, 500);
    });
  }

  getListByFilter() {
    const payload = this.getPayload();
    this.pager.perPage = payload.perPage;
    delete payload.perPage;
    this.getList(this.pager.currentPage, payload);
  }

  getList(page: number, payload: any) {
    payload.currentPage = page;
    payload.perPage = this.pager.perPage;
    this.isLoading = true;
    this.dealsService
      .getCustomProductsList(payload)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response.records) {
          this.productList = response.records;
          this.renderPagination(
            response.page,
            response.total,
            response.totalPage
          );
        }
      },
      (error: any) => {
        console.log('Deal list error:', error);
        this.isLoading = false;
      });
  }

  goPage() {
    const goto = this.nameInput.nativeElement.value;
    this.setPage(goto);
    this.nameInput.nativeElement.value = '';
  }

  setPage(page: any) {
    if (
      0 < page &&
      page <= this.pager.TotalPages &&
      page != this.pager.currentPage
    ) {
      this.pager.currentPage = page;
      this.getListByFilter();
    }
  }

  renderPagination(page: number, total: number, totalPage: number) {
    this.pager.currentPage = page;
    this.pager.Totalrecords = total;
    this.pager.TotalPages = totalPage;
    this.PageList = this.utilService.getPageList(
      this.pager.TotalPages,
      this.pager.currentPage
    );
  }

  onBrandChange(selectedBrand: string): void {
    console.log(selectedBrand);
    // let filtered:any = this.productMaster.find((element) => element.slug==selectedBrand);
    // this.categories = filtered.category?filtered.category:[];
    // console.log(this.categories)
  }

    getProductsarray() {
    // console.log('arayyyy');
    this.isProductLoading = true;
    this.dealsService
      .getProductsarray('master')
      .pipe(
        finalize(() => {
          this.isProductLoading = false;
        })
      )
      .subscribe((response: any) => {
        this.productMaster = response;
      });
  }

  openPop(modal: any, product: any) {
    if (product) {
      this.editingItemId = product._id;
      this.modalMode = 'Update';
      this.customCreateForm.reset({
        name: product.name,
        brand: product.brand,
        category: product.category,
        order: product.order,
        disable: product.disable?true:false
      });
      if(product.brand) this.onBrandChange(product.brand);
    } else {
      this.modalMode = 'create';
      this.editingItemId = null;
      this.customCreateForm.reset({
        name: '',
        brand: 'DOWC',
        category: 'other',
        order: 1,
        disable: false
      });
    }
    const modalRef = this.modalService.open(modal, { backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        // this.confirmChangeStatus(dealId);

      }
    });
  }

  openDelete(modal: any, productId: string){
    const modalRef = this.modalService.open(modal, { backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        this.dealsService
      .removeCustomProduct(productId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.toastrService.info('Deal successfully sent for build!');
          // this.modalRef.close();  
          // this.getListByFilter();
            setTimeout(() => {
              window.location.reload();
            }, 1000);

        },
        (error: any) => {
          console.log(
            'Confirmation modal error:',
            error.error.validation.errors
          );
          this.isLoading = false;
        }
      );
      }
    });
  }

  submitGroup() {
    if (this.customCreateForm.invalid) {
      for (const i in this.customCreateForm.controls) {
        this.customCreateForm.controls[i].markAsTouched();
      }
      return;
    }
    let payload=this.customCreateForm.value;
    payload.slug=this.utilService.convertSlug(payload.name);
    this.isLoading = true;
    this.dealsService
      .submitCustomProduct(this.customCreateForm.value,this.editingItemId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.toastrService.info('Deal successfully sent for build!');
          // this.modalRef.dismiss();  
          // this.getListByFilter();
           setTimeout(() => {
              window.location.reload();
            }, 1000);

        },
        (error: any) => {
          console.log(
            'Confirmation modal error:',
            error.error.validation.errors
          );
          this.isLoading = false;
        }
      );
  }

  getPayload() {
    let payload = JSON.parse(JSON.stringify(this.fiterForm.value));
    payload = this.utilService.removeEmpty(payload);
    return payload;
  }

  

  omit_special_char(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  omit_special_Mailchar(event: any) {
    let k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k <= 122) ||
      k === 46 ||
      k === 64 ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }


  async openHelpPopup() {
    const modalRef = await this.modalService.open(DealHelpComponent);
  }
}


